import { render, staticRenderFns } from "./order-tracking.vue?vue&type=template&id=f89adf18&"
import script from "./order-tracking.vue?vue&type=script&lang=js&"
export * from "./order-tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports